import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import Input from '../../Form/Field/Input.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Select from '../../Form/Field/Select.jsx'
import validate from './validate.js'
import {generate} from '../../../routes.js'

export const name = 'BringBusinessForm'

class BringBusinessForm extends PureComponent {
  render() {
    const linkCGU = <Link to={generate({name: 'bring-business-cgu'})} target="_blank" rel="noopener noreferrer">
      CGU
    </Link>

    return (
      <div id={name} className={this.props.className}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          {!this.props.isConnected ?
            <fieldset className="form-group p-3 p-md-5">
              <legend>Vos coordonnées</legend>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    label="Prénom : *"
                    name="firstname"
                    placeholder="Prénom"
                    type="text"
                    component={Input}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    label="Nom : *"
                    name="lastname"
                    placeholder="Nom"
                    type="text"
                    component={Input}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    label="E-mail : *"
                    name="email"
                    placeholder="E-mail"
                    type="text"
                    component={Input}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    label="Numéro de téléphone : *"
                    name="phone"
                    placeholder="06 10 11 12 21"
                    type="text"
                    component={Input}
                  />
                </div>
              </div>
            </fieldset> : ''}
          <fieldset className="form-group p-3 p-md-5 mb-4">
            <legend>Informations relatives à l'affaire / au client</legend>
            <div className="row">
              <div className="col-md-12">
                <Field
                  label="Domaine : *"
                  name="universe"
                  component={Select}>
                  {this.props.universes.map((universe) => (
                    <option value={universe.id} key={universe.id}>{universe.name}</option>
                  ))}
                </Field>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="Prénom du contact client : *"
                  name="contact_firstname"
                  placeholder="Prénom"
                  type="text"
                  component={Input}
                />
              </div>
              <div className="col-md-6">
                <Field
                  label="Nom du contact client : *"
                  name="contact_lastname"
                  placeholder="Nom"
                  type="text"
                  component={Input}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="E-mail :"
                  name="contact_email"
                  placeholder="E-mail"
                  type="text"
                  component={Input}
                />
              </div>
              <div className="col-md-6">
                <Field
                  label="Numéro de téléphone :"
                  name="contact_tel"
                  placeholder="06 10 11 12 21"
                  type="text"
                  component={Input}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="Société : *"
                  name="company"
                  placeholder="Société"
                  type="text"
                  component={Input}
                />
              </div>
              <div className="col-md-6">
                <Field
                  label="Titre du poste à pourvoir : *"
                  name="contact_job"
                  placeholder="Poste"
                  type="text"
                  component={Input}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Field
                  label="Description de la mission :"
                  name="description"
                  type="textarea"
                  component={Input}
                />
                <em>
                  Type de profil recherché, contexte, localisation, durée de la mission, séniorité, % de télétravail,
                  budget ...
                </em>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Field
                  className="mr-3"
                  wrapperClassName="d-flex align-items-md-center"
                  label={
                    <span>
                      En cochant cette case, je reconnais avoir pris connaissance des {linkCGU} et de les accepter dans
                      leur totalité. Je recevrai un mail contenant les informations marché que je viens de transmettre et
                      comportant les engagements de Twineeds conformément aux {linkCGU}.
                    </span>
                  }
                  name="cgu_accepted"
                  type="checkbox"
                  spaceBeforeLabel={false}
                  component={Input}/>
              </div>
            </div>
          </fieldset>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    )
  }
}

const ReduxBringBusinessForm = reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(BringBusinessForm)

export default connect(
  (state) => ({
    isConnected: Boolean(state.currentUser?.user?.id),
    universes: state.universe.universes
  })
)(ReduxBringBusinessForm)